// extracted by mini-css-extract-plugin
export var childrenContainer = "_bs-0";
export var virtualScrollArea = "_bs-1";